import type { ChatRoom } from 'models';
import { useMemo } from 'react';
import { useGetChatroomName } from '../../hooks';

type P = Pick<ChatRoom, 'name' | 'participants' | 'users'>;

export const useGroupChatRoomInfo = ({
  name,
  participants,
  users,
}: P): {
  membersCount: number;
  name: string;
} => {
  const getChatroomName = useGetChatroomName();

  return useMemo(
    () => ({
      membersCount: users.length,
      name: getChatroomName({ name, participants, users }),
    }),
    [getChatroomName, name, participants, users],
  );
};
